export default "__VITE_ASSET__DQzC3lAt__"